const colors = [
  'amber',
  'blue',
  'cyan',
  'green',
  'grey',
  'indigo',
  'light-blue',
  'lime',
  'orange',
  'pink',
  'purple',
  'red',
  'teal',
  'violet',
  'yellow'
];

export function normalizeGroupKey(group) {
  const key = String(group || 'default').trim();
  const lowerKey = key.toLowerCase();
  if (lowerKey === 'pro' || lowerKey === 'vip') {
    return 'vip';
  }
  if (lowerKey === 'elite' || lowerKey === 'svip' || lowerKey === 'premium') {
    return 'svip';
  }
  if (lowerKey === '') {
    return 'default';
  }
  return key;
}

export function displayGroupName(group) {
  const key = normalizeGroupKey(group);
  if (key === 'default') {
    return 'default';
  }
  if (key === 'vip') {
    return 'vip';
  }
  if (key === 'svip') {
    return 'svip';
  }
  return group || 'default';
}

export function buildGroupOptions(groups = []) {
  const seen = new Set();
  const baseGroups = ['default', 'vip', 'svip'];
  return [...baseGroups, ...groups].reduce((options, group) => {
    const value = normalizeGroupKey(group);
    if (seen.has(value)) {
      return options;
    }
    seen.add(value);
    options.push({
      label: displayGroupName(value),
      value
    });
    return options;
  }, []);
}

export function stringToColor(str) {
  let sum = 0;
  const value = String(str || '');
  for (let i = 0; i < value.length; i++) {
    sum += value.charCodeAt(i);
  }
  return colors[sum % colors.length];
}
